import React from 'react';

const Marquee = ({ text, bgColor = 'bg-rush-blue', textColor = 'text-white', speed = 'normal' }) => {
  const speedClass = speed === 'slow' ? 'animate-marquee' : 'animate-marquee';
  
  return (
    <div className={`${bgColor} py-3 overflow-hidden whitespace-nowrap`}>
      <div className={`inline-flex ${speedClass}`}>
        {[...Array(10)].map((_, i) => (
          <span key={i} className={`${textColor} text-lg md:text-xl font-bold mx-8 flex items-center`}>
            {text}
            <span className="mx-4 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
